<template>
  <div>
    <h1 class="mb-3"><span class="text-blue">Agenda</span> <span class="text-red">Perindo</span></h1>
    <!-- -----------------------warning------ -->
    <!-- <div class="snackbarWarn mb-1">
        <div class="warnIcon">
            <i class="fas fa-exclamation-circle"></i>
        </div>

        <div class="warnText">Terdapat Pembekalan Caleg & Konsolidasi Daerah Jawa Barat 2021, segera lihat agenda
            dan daftarkan dirimu ke DPD terdekat.</div>
    </div> -->
    <div class="selectTg">
      <div class="text-blue text-bold">Pilih Tanggal</div>
      <div class="selCalender" @click="updateCal(true)">{{formatedDate? formatedDate : 'Semua Tanggal'}} <i class="fas fa-chevron-down"></i></div>
    </div>
    <agenda type="agenda" :list="agendaList" @dateselected="getTodayEvent" :loading="isLoading">
      Agenda Mendatang
    </agenda>
    <div class="cardCalendar" v-if="showCal">
        <div class="card cardDatePicker">
            <DatePicker title-position="left" :first-day-of-week="2" v-model="selectedDate"
                :masks="{ title: 'MMM YYYY', weekdays: 'WW' }" :attributes='attrs' class="agendaMobile" />
            <button class="btn-fill blue text-bold rounded" @click="updateCal(false), hasValue = true" v-if="!hasValue">Pilih Tanggal</button>
            <button class="btn-fill red text-bold rounded" @click="deleteDate()" v-else>Hapus Pilihan Tanggal</button>
        </div>
        <div class="overlay-wrap modal" :class="{'active': showCal}" @click="updateCal(false)">
        </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker
} from 'v-calendar'
import agenda from '../../components/calendarAgenda.vue'
import axios from 'axios'

export default {
  components: {
    agenda,
    DatePicker
  },
  data () {
    return {
      attrs: [{
        // key: 'today',
        dot: {
          style: {
            backgroundColor: '#ed1c24'
          },
          class: 'customDot'
        },
        dates: new Date()
      }],
      showCal: false,
      selectedDate: null,
      formatedDate: '',
      hasValue: false,
      agendaList: [],
      isLoading: false
    }
  },
  mounted () {
    document.title = 'Dashboard - Agenda'
    this.getTodayEvent(new Date())
  },
  methods: {
    async getTodayEvent (date) {
      this.isLoading = true
      this.agendaList = []
      const selected = `${date.getFullYear()}-${date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`
      try {
        const { data: { data } } = await axios.get('content/listeventbydate', {
          params: {
            limit: 10,
            page: 1,
            date_filter: selected
          }
        })
        this.agendaList = data || []
        this.isLoading = false
      } catch {
        this.isLoading = false
      }
      this.isLoading = false
    },
    updateCal (val) {
      if (this.selectedDate && !val) this.getTodayEvent(this.selectedDate)
      this.showCal = val
      this.$store.commit('setCardIsShow', this.showCal)
    },
    formateDate (val) {
      if (val != null) {
        const months = ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September',
          'Oktober', 'November', 'December'
        ]
        const currentTime = val
        this.formatedDate = currentTime.getDate() + ' ' + months[currentTime.getMonth()] + ' ' + currentTime.getFullYear()
      } else {
        this.formatedDate = null
        this.hasValue = false
      }

      this.logger(this.formatedDate)
    },
    deleteDate () {
      this.selectedDate = null
      this.updateCal(false)
    }
  },
  watch: {
    selectedDate (newVal, old) {
      // this.logger(newVal, old)
      this.formateDate(newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
    h1 {
        @media only screen and (max-width: 600px) {
            font-size: 16px;
            margin-bottom: 2rem !important;
            margin-top: 2rem;
        }
    }

    .snackbarWarn {
        border: 1px solid $red;
        border-radius: 5px;
        display: flex;

        @media only screen and (max-width: 600px) {
            background-color: #fee8e8;
            align-items: center;
        }

        .warnIcon {
            padding: 10px;
            border-right: 1px solid $red;
            color: $red;
            width: 4%;
            text-align: center;

            @media only screen and (max-width: 600px) {
                border-right: none;
                //   background-color: #fee8e8;
            }

            @media only screen and (max-width: 800px) {
                min-width: 40px;
            }
        }

        .warnText {
            padding: 10px;
            font-size: 12px;
            color: $red;
            background-color: #fee8e8;
            width: 96%;
        }
    }

    .selectTg {
        margin: 2rem 0;
        display: none;
        text-align: right;

        @media only screen and (max-width: 600px) {
            display: block;
        }

        .selCalender {
            i {
                font-size: 12px;
                font-weight: bold;
                margin: 0 10px;
            }
        }
    }

    .cardDatePicker {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        left: 50%;
        padding: 1rem;
        z-index: 999;

        .agendaMobile {
            border: none;
        }

        button {
            width: 100%;
            padding: 1rem;
        }
    }
</style>
